import {createClient} from 'contentful';

const contentfulClientApi = createClient({
    space: process.env.REACT_APP_CONTENTFUL_SPACE_ID || 'xxx',
    accessToken: process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN || 'xxx'
});

export default contentfulClientApi